import { Grid2, Grid, Typography, Box, Chip } from "@mui/material";
import styles from "./PricingMobileView.module.css";
import Divider from "@mui/material/Divider";
import accLogo from "../../../Assets/Images/acc_open_charges_mobile_logo.svg";
import equityLogo from "../../../Assets/Images/equity_brokerage_mobile_logo.svg";
import fnoLogo from "../../../Assets/Images/fno_brokerage_mobile_logo.svg";
import pledgeLogo from "../../../Assets/Images/pledge_mobile_logo.svg";
import en from "../../../i18n/English/Pricing/pricing.json";
import hi from "../../../i18n/Hindi/Pricing/pricing.json";
import kn from "../../../i18n/Kannada/Pricing/pricing.json";
import ma from "../../../i18n/Marathi/Pricing/pricing.json";
import gu from "../../../i18n/Gujarati/Pricing/pricing.json";
import { useLanguage } from "../../../Context/LangContext";
import DocumentMeta from 'react-document-meta'

const meta = {
  title: 'Trading Pricing Plans | Affordable Trading & Wealth Tools | TradeBoss',
  description: 'Start trading with TradeBoss plans from ₹499/year. Get SEBI-registered advice & advanced Wealth Vault tools to manage investments confidently.',
  canonical: 'https://tradeboss.co/pricing',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: 'tradeboss pricing, brokerage pricing India, subscription plans trading, trading fees plans, affordable trading plans, tradeboss cost, cost to open demat account, brokerage and subscription charges'
    }
  }
}
export default function MobileView() {
  const { language } = useLanguage();
  const translations = { en, hi, kn, ma, gu };
  const t = translations[language];
  return (
    <>
      <Grid2 className={styles.main_grid}>
        <DocumentMeta {...meta} />
      <Typography className={styles.heading} sx={{fontWeight:"700"}}>{t.heading}</Typography>
        <Grid2 className={styles.sub_grid}>
          <Box className={styles.sub_heading_box}>
            <Typography>{t.sub_heading}</Typography>
          </Box>
        </Grid2>

        {/* <Grid2 container className={styles.pricing_charges}>
          <Grid2 item className={styles.pricing_box}>
            <Box>
              <Grid2 className={styles.logo_grid}>
                <Typography className={styles.price}>₹0</Typography>
                <img
                  src={accLogo}
                  alt="Account Opening Logo"
                  loading="lazy"
                  sx={{
                    zIndex: 1,
                  }}
                  className={styles.logo}
                ></img>
              </Grid2>
              <Typography className={styles.price_heading}>
                {t.pricing_boxes[0].heading}
              </Typography>
              <Typography className={styles.price_sub_heading}>
                {t.pricing_boxes[0].sub_heading}
                <br /> {t.pricing_boxes[0].text}
              </Typography>
            </Box>
          </Grid2>
          <Grid2 item className={styles.pricing_box}>
            <Box>
              <Grid2 className={styles.logo_grid}>
                <Typography className={styles.price}>₹20/0.05%</Typography>
                <img
                  src={equityLogo}
                  alt="Equity Brokerage Logo"
                  loading="lazy"
                  sx={{
                    zIndex: 1,
                  }}
                  className={styles.logo}
                ></img>
              </Grid2>
              <Typography className={styles.price_heading}>
                {t.pricing_boxes[1].heading}
              </Typography>
              <Typography className={styles.price_sub_heading}>
                {t.pricing_boxes[1].sub_heading}
              </Typography>
            </Box>
          </Grid2>
          <Grid2 item className={styles.pricing_box}>
            <Box>
              <Grid2 className={styles.logo_grid}>
                <Typography className={styles.price}>₹20/0.05%</Typography>
                <img
                  src={fnoLogo}
                  alt="Fno Brokerage Logo"
                  loading="lazy"
                  sx={{
                    zIndex: 1,
                  }}
                  className={styles.logo}
                ></img>
              </Grid2>
              <Typography className={styles.price_heading}>
                {t.pricing_boxes[2].heading}
              </Typography>
              <Typography className={styles.price_sub_heading}>
                {t.pricing_boxes[2].sub_heading}
              </Typography>
            </Box>
          </Grid2>
          <Grid2 item className={styles.pricing_box}>
            <Box>
              <Grid2 className={styles.logo_grid}>
                <Typography className={styles.price}>₹20/0.05%</Typography>
                <img
                  src={pledgeLogo}
                  alt="Pledge Logo"
                  loading="lazy"
                  sx={{
                    zIndex: 1,
                  }}
                  className={styles.logo}
                ></img>
              </Grid2>
              <Typography className={styles.price_heading}>{t.pricing_boxes[3].heading}</Typography>
              <Typography className={styles.price_sub_heading}>
                {t.pricing_boxes[3].sub_heading}
              </Typography>
            </Box>
          </Grid2>
        </Grid2> */}

      <Grid2 className={styles.playout} >

                <Grid2 className={styles.card} >
                  <Grid2 className={styles.card2} >
                    {/* <div className={styles.img_back}> */}
                    <img className={styles.logo} src={accLogo} alt="icon"></img>
                    {/* </div> */}
                  </Grid2>
                  <Typography className={styles.amount}>₹499</Typography>
                  <div className={styles.info_div}>
                    <Typography className={styles.cardhead}>{t.pricing_boxes[0].heading}</Typography>
                    <Typography className={styles.cardheadsub}>{t.pricing_boxes[0].sub_heading}
                      <br /> {t.pricing_boxes[0].text}</Typography>
                  </div>
                </Grid2>

                <Grid2 className={styles.card} >
                  <Grid2 className={styles.card2} >

                   <img className={styles.logo}  src={equityLogo} alt='icon'></img>

                  </Grid2>
                  <Grid container sx={{ display: 'flex !important', flexDirection: 'row !important', alignItems: 'center' }}>
                    <Grid item xs={12} md={12} lg={6}>
                      <Typography className={styles.amount} >0.03%</Typography>
                      <Typography className={styles.cardheadsub_2}>{t.pricing_boxes[1].delivery}</Typography>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6} >
                      <Typography className={styles.amount}>0.015%</Typography>
                      <Typography className={styles.cardheadsub_2}>{t.pricing_boxes[1].intraday}</Typography>
                    </Grid>
                  </Grid>
                  <Typography className={styles.cardhead}>{t.pricing_boxes[1].heading}</Typography>
                  <Typography className={styles.cardheadsub}>{t.pricing_boxes[1].sub_heading}</Typography>
                </Grid2>

                <Grid2 className={styles.card} >
                  <Grid2 className={styles.card2} >
                    <img className={styles.logo}  src={fnoLogo} alt="icon"></img>
                  </Grid2>
                  <Grid container sx={{ display: 'flex !important', flexDirection: 'row !important' }}>
                    <Grid item xs={12} md={12} lg={6}>
                      <Typography className={styles.amount}>0.03%</Typography>
                      <Typography className={styles.cardheadsub_2}>{t.pricing_boxes[2].futures}</Typography>
                    </Grid>
                    <Grid itemxs={12} md={12} lg={6}>
                      <Typography className={styles.amount}>₹15 {t.pricing_boxes[2].lot}</Typography>
                      <Typography className={styles.cardheadsub_2}>{t.pricing_boxes[2].options} </Typography>
                    </Grid>
                  </Grid>
                  <Typography className={styles.cardhead}>{t.pricing_boxes[2].heading}</Typography>
                  <Typography className={styles.cardheadsub}>{t.pricing_boxes[2].sub_heading}</Typography>
                </Grid2>

                <Grid2 className={styles.card} >
                  <Grid2 className={styles.card2} >
                    {/* <div className={styles.img_back}> */}
                    <img src={pledgeLogo} alt='icon' className={styles.logo}></img>
                    {/* </div> */}
                  </Grid2>
                  <Typography className={styles.amount}>₹50</Typography>
                  <div className={styles.info_div}>
                    <Typography className={styles.cardhead}>{t.pricing_boxes[3].heading}</Typography>
                    <Typography className={styles.cardheadsub}>{t.pricing_boxes[3].sub_heading}</Typography>
                  </div>
                </Grid2>

              </Grid2>

        <Grid2 className={styles.regulatory_grid}>
          <div className={styles.regulatory_div}>
            <Typography className={styles.regulatory_heading}>
              {t.regulatory_heading}
            </Typography>
          </div>
          <Grid2 className={styles.color_legend_grid}>
            <Typography className={styles.legendary}>{t.color_legend.title}</Typography>
            <span className={styles.circle_green}></span>
            <Typography className={styles.buy_text}>{t.color_legend.buy}</Typography>
            <span className={styles.circle_red}></span>
            <Typography className={styles.sell_text}>{t.color_legend.sell}</Typography>
          </Grid2>
        </Grid2>

        <Grid2>
          <Grid2 container className={styles.regulatory_sub_grid1}>
            <table className={styles.styled_table} align="center" width="100%">
              <tbody>
                <tr>
                  <td rowSpan="2" className={styles.table_cell}></td>
                  <td
                    colSpan="2"
                    className={`${styles.heading_style} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.headers[0]}
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.headers[0]}
                  </td>
                  <td
                    className={`${styles.sub_heading_styles} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.headers[1]}
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles2} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.rows[0].name}
                  </td>

                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.025%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>

                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.1%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles2} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.rows[1].name}
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.003%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.015%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles2} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.rows[2].name}
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>{t.regulatory_table.rows[2].values[0].value}</div>
                    <div className={styles.percentage_padding}>
                      {t.regulatory_table.rows[2].values[0].value1}
                    </div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>{t.regulatory_table.rows[2].values[1].value}</div>
                    <div className={styles.percentage_padding}>
                      {t.regulatory_table.rows[2].values[1].value1}
                    </div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles2} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.rows[3].name}
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.0001%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.0001%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles2} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.rows[4].name}
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.0001%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>{t.regulatory_table.rows[4].values[1].value}</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles2} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.rows[5].name}
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>{t.regulatory_table.rows[5].values[0].value}</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>{t.regulatory_table.rows[5].values[1].value}</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </Grid2>

          <Grid2 container className={styles.regulatory_sub_grid2}>
            <table className={styles.styled_table} align="center" width="100%">
              <tbody>
                <tr>
                  <td rowSpan="2" className={styles.table_cell}></td>
                  <td
                    colSpan="2"
                    className={`${styles.heading_style} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.headers[4]}
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.headers[2]}
                  </td>
                  <td
                    className={`${styles.sub_heading_styles} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.headers[3]}
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles2} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.rows[0].name}
                  </td>

                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.125%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>

                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.0625% {t.regulatory_table.rows[0].values}</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles2} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.rows[1].name}
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.002%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.003%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles2} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.rows[2].name}
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>{t.regulatory_table.rows[2].values[2].value}</div>
                    <div className={styles.percentage_padding}>{t.regulatory_table.rows[2].values[2].value1}</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>{t.regulatory_table.rows[2].values[3].value} </div>
                    <div className={styles.percentage}>{t.regulatory_table.rows[2].values[3].values3}</div>
                    <div className={styles.percentage_padding}>{t.regulatory_table.rows[2].values[3].value1}</div>
                    <div className={styles.percentage}>{t.regulatory_table.rows[2].values[3].values3}</div>

                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles2} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.rows[3].name}
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.0001%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.0001%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles2} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.rows[4].name}
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>₹0</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>₹0</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${styles.sub_heading_styles2} ${styles.table_cell}`}
                  >
                    {t.regulatory_table.rows[5].name}
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.0001%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                  <td className={styles.table_cell}>
                    <div className={styles.percentage}>0.0005%</div>
                    <div className={styles.dots}>
                      <div
                        className={`${styles.circle_red} ${styles.circle_padding}`}
                      ></div>
                      <div
                        className={`${styles.circle_green} ${styles.circle_padding}`}
                      ></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </Grid2>
        </Grid2>

        {/* Demat box Start */}
        <Grid2 className={styles.demat_main_grid}>
          <Typography className={styles.penalty_heading} sx={{ fontWeight: "700" }}>
            {t.demat_heading}
          </Typography>
          <Box className={styles.demat_box}>
            <Grid2 className={styles.penalty_grid1}>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text_heading}>
                      {t.demat_charges[11].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text_heading}>
                      {t.demat_charges[11].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.demat_charges[0].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>{t.demat_charges[0].value}</Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.demat_charges[1].name}
                    </Typography>
                    <Typography className={styles.demat_text1}>
                      {t.demat_charges[1].value1}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>
                      {t.demat_charges[1].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.demat_charges[2].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>
                      {t.demat_charges[2].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.demat_charges[3].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>
                      {t.demat_charges[3].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.demat_charges[4].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>
                      {t.demat_charges[4].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.demat_charges[5].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>
                      {t.demat_charges[5].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.demat_charges[6].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>    {t.demat_charges[6].value}</Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.demat_charges[7].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>
                      {t.demat_charges[7].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.demat_charges[8].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>
                      {t.demat_charges[8].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.demat_charges[9].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>
                      {t.demat_charges[9].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.demat_charges[10].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>    {t.demat_charges[10].value}</Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
            </Grid2>
          </Box>
          <Typography className={styles.tax_txt}>
            {t.tax_note}
          </Typography>
        </Grid2>
        {/* Demat box end */}

        <Grid2 className={styles.penalties_main_grid}>
          <Typography className={styles.penalty_heading}>{t.penalties_heading}</Typography>

          <Box className={styles.demat_box}>
            <Grid2 className={styles.penalty_grid1}>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text_heading}>
                      {t.demat_charges[11].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text_heading}>
                      {t.demat_charges[11].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.penalties[0].name} {t.penalties[0].name1}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>
                      {t.penalties[0].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.penalties[1].name} {t.penalties[1].name1}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>
                      {t.penalties[1].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 item className={styles.demat_sub_grid}>
                <Grid2 container>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text1}>
                      {t.penalties[2].name}
                    </Typography>
                  </Grid2>
                  <Grid2 className={styles.demat_equal_grid}>
                    <Typography className={styles.demat_text2}>
                      {t.penalties[2].value}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
            </Grid2>
          </Box>

          <Box className={styles.penalty_box1}>
            <Grid2 className={styles.penalty_grid1}>
              <Typography className={styles.gst_heading1}>{t.gst_section.heading1}</Typography>
              <Typography className={styles.gst_text}>
                {t.gst_section.text1}
                <br />
                {t.gst_section.text2}
              </Typography>
              <Typography className={styles.gst_heading2}>
                {t.gst_section.heading2}
              </Typography>
              <Typography className={styles.gst_text}>
                {t.gst_section.text3}
                <br />
                {t.gst_section.text4}
              </Typography>
            </Grid2>
          </Box>
        </Grid2>
      </Grid2>
    </>
  );
}
